import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../apis/store";
import Loader from "../../../biblio/Loader/Loader";
import NavBar from "../../communs/NavBar";
import HeroSectionDetailsProject from "../layout-details-project/HeroSectionDetailsProject";
import headerBg from "../../../assets/background/headebg.png";
import headerMobileBg from "../../../assets/images/heroMobile3.jpg";
import { Col, Row } from "antd";
import CardDetailsProject from "../../../components/card-details-project/CardDetailsProject";
import DonationCard from "../../../biblio/Cards/DonationCard";
import FooterSection from "../../../components/sections/FooterSection";
import {
  getDetailsGeneralDonation,
  getGeneralDonationTypes,
} from "../../../apis/actions/generalDonations.actions";
import OtherGenralDonationCard from "./OtherGenralDonationCard";
import Seo from "../../../components/seo/Seo";

const LayoutDetailsGeneralDonation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const donationAmount = location.state?.donationAmount;
  const counter = location.state?.counter;
  const selectedShare = location.state?.selectedShare;
  const selectedDonation = location.state?.selectedDonation;
  const dispatch = useDispatch<AppDispatch>();
  const { access_token } = useParams();
  const [loading, setLoading] = useState(true);

  const { detailsGeneralDonation, donationTypes } = useSelector(
    (state: RootState) => state?.generalDonations
  );
  useEffect(() => {
    dispatch(getDetailsGeneralDonation(access_token));
    setLoading(true);
    dispatch(getGeneralDonationTypes());
  }, [dispatch, access_token]);

  useEffect(() => {
    if (
      detailsGeneralDonation &&
      Object.keys(detailsGeneralDonation).length === 0
    ) {
      navigate("/");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailsGeneralDonation]);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  const handleClick = (body: any) => {
    console.log(body);
  };
  return (
    <div className="takaful--layout-details">
      <Seo
        title={detailsGeneralDonation?.name}
        description={detailsGeneralDonation?.summary}
        image={
          detailsGeneralDonation?.detail_image_ids?.[0] ??
          detailsGeneralDonation?.title_image_ids?.[0]
        }
      />
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="التبرعات"
        subTitle="تفاصيل التبرعات"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"التبرع العام"}
      />
      <Row dir="rtl" gutter={16} justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={14}
          xl={14}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <CardDetailsProject
            project={detailsGeneralDonation}
            type="التبرع العام"
          />
        </Col>
        <Col
          xxl={7}
          xl={7}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <DonationCard
            project={detailsGeneralDonation}
            handleClick={handleClick}
            donationAmounts={[]}
            donationTypes={donationTypes}
            variant="payment"
            className="takaful--donation-details"
            donationAmount={donationAmount}
            counter={counter}
            selectedShare={selectedShare}
            selectedDonation={selectedDonation}
            remainingAmount={detailsGeneralDonation?.remaining_amount}
            type="التبرع العام"
          />
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>
      <OtherGenralDonationCard />
      <FooterSection />
    </div>
  );
};

export default LayoutDetailsGeneralDonation;
